import { Component, Host, h, Element, Prop } from '@stencil/core';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

export interface AhaEventListItem extends HTMLAhaEventListItemElement {}

/**
 * The "event item" element.
 *
 * Note that the width of the "time" area (the section on the left) can be adjusted by tweaking the value of a CSS variable `--aha-event-list-item--time-width` with any valid CSS unit value.
 *
 * Typically used inside an `<aha-event-list>` ("event list") element.
 */
@Component({
  tag: 'aha-event-list-item',
  styleUrl: 'aha-event-list-item.css',
  shadow: true,
})
export class AhaEventListItem {
  @Element() host!: HTMLAhaEventListItemElement;

  /** The time to be shown. Must be in format HH:mm. */
  @Prop({ reflect: true }) time!: string;

  render() {
    const time = dayjs(this.time, 'HH:mm');

    return (
      <Host role="listitem">
        <div class="event-list-item-container">
          <div class="time">
            <span>{time.format('LT').toLowerCase()}</span>
          </div>
          <div class="line"></div>
          <div id="content">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
